module.exports = __webpack_public_path__ + "static/media/icon_sound_low.4a160604.png";